import CityPageTemplate from "../city-template/CityPageTemplate";
import { lansingConfig } from "./data";

export default function LansingMIPage() {
  return <CityPageTemplate config={lansingConfig} />;
}